export const callStatusStyles = {
  baseStyle: 'flex justify-center pt-[12px] min-h-[30px]',
  textStyle: 'text-[14px] text-foreground',
};

export const holdingLabelStyle = 'text-[14px] text-warning font-medium';
